/**
 * @desc 识别身份证图片信息
 */
import { OcrOptions } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type RecognizeIdCardParameter = OcrOptions

const method = 'POST'
const url = '/nexus/ocr/recognizeIdCard'

export const recognizeIdCardApi = (
  data?: RecognizeIdCardParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    data,
    ...config
  })
}

recognizeIdCardApi.method = method
recognizeIdCardApi.url = url
